import React from 'react';
import {PlayersDashboard as ClassicPlayersDashboard} from './classic';
import {PlayersDashboard as SinglegamePlayersDashboard} from './single-game';

const PlayersDashboard = {
    get(sportConfig) {
        if (sportConfig.isGameTypeClassic()) {
            return ClassicPlayersDashboard;
        } else if (sportConfig.isGameTypeSingleGame()) {
            return SinglegamePlayersDashboard;
        }

        throw new Error(`getFilter ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {PlayersDashboard};
